module.exports = __webpack_public_path__ + "img/2.25439c2b.png";